<template>
  <div>
    <div class="search" :style="`min-height: ${windowHeight}px`">
      <FixedHeader
        @clickedLogin="showLogin = !showLogin"
        :showLogin="showLogin"
        :showLoginBtn="!showSearch || windowWidth >= 700"
        @show="showSearchInput"
        :showSearchInput="showSearch"
        @input="search"
        :value="searchValue"
        :view="'search'"
      >
        <div
          v-if="!showSearch || windowWidth >= 700"
          class="menu-button"
          @click="backUrl ? $router.push(backUrl) : goTo()"
        >
          <b-icon icon="arrow-left"></b-icon>
        </div>
        <a @click="goTo()">
          <img
            v-if="!showSearch && windowWidth >= 370"
            class="logo"
            alt="Pinwall logo"
            :src="
              require(`../assets/img/${
                darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
              }`)
            "
          />
        </a>
      </FixedHeader>
      <span v-if="isDataLoaded" class="post-found">{{
        postCount > 1
          ? `${postCount} ${$t("postsFound")}`
          : `${postCount} ${$t("postFound")}`
      }}</span>
      <div class="buttons">
        <b-button
          v-if="windowWidth > mobileWidth"
          icon-left="view-quilt"
          :class="view.grid ? 'is-selected' : 'is-text'"
          @click="setGridView"
          :title="$t('views.gridView')"
        ></b-button>
        <b-button
          v-if="windowWidth > mobileWidth"
          icon-left="view-agenda"
          :class="view.list ? 'is-selected' : 'is-text'"
          @click="setListView"
          :title="$t('views.listView')"
        ></b-button>
        <b-dropdown
          aria-role="list"
          v-model="sort"
          @change="sortPosts"
          position="is-bottom-left"
        >
          <button
            class="button is-primary is-rounded sort-button"
            slot="trigger"
          >
            <span>{{ $t(`sort.${sort}`) }}</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item disabled>Sorting</b-dropdown-item>
          <b-dropdown-item value="new" aria-role="listitem">{{
            $t("sort.new")
          }}</b-dropdown-item>
          <b-dropdown-item value="old" aria-role="listitem">{{
            $t("sort.old")
          }}</b-dropdown-item>
          <b-dropdown-item value="likes" aria-role="listitem">{{
            $t("sort.likes")
          }}</b-dropdown-item>
        </b-dropdown>
      </div>
      <Grid
        v-if="view.grid && windowWidth > mobileWidth"
        :editable="false"
        :posts="searchPosts"
        :mode="'search'"
        @fullscreen="fullscreen"
        @filePreview="filePreview"
        @ended="$refs.controls.next()"
      ></Grid>
      <List
        v-if="view.list || windowWidth <= mobileWidth"
        :posts="searchPosts"
        :mode="'search'"
        @fullscreen="fullscreen"
        @filePreview="filePreview"
        @ended="$refs.controls.next()"
      ></List>
      <b-modal class="fullscreen" :active.sync="isFullscreenModalActive">
        <Post :post="post" :mode="'fullscreen'" />
      </b-modal>

      <b-modal class="fullscreen" :active.sync="isFilePreviewModalActive">
        <FileViewer :post="post" :mode="'fullscreen'" />
      </b-modal>
      <Controls ref="controls" :posts="searchPosts" />
      <div v-if="isLoading" class="loading-container">
        <b-loading
          v-if="view.grid"
          :is-full-page="false"
          :active.sync="isLoading"
          :can-cancel="true"
        ></b-loading>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import FixedHeader from "@/components/FixedHeader";
import Footer from "@/components/Footer";
import Controls from "@/components/core/Controls";
import Grid from "@/components/pinwall/Grid";
import FileViewer from "@/components/pinwall/FileViewer";
import Post from "../components/pinwall/Post";
import List from "@/components/pinwall/List";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { goTo } from "../mixins/goTo.js";
import { checkIfMobileOrTablet } from "../utils/helpers";
import { getScrollY } from "../mixins/getScrollY";

export default {
  name: "search",
  components: {
    FixedHeader,
    Footer,
    Grid,
    List,
    Controls,
    FileViewer,
    Post
  },
  data: () => {
    return {
      sort: "new",
      mobileWidth: process.env.VUE_APP_MOBILE_WIDTH,
      isFullScreen: false,
      showSearch: false,
      initialLoad: true,
      isMobileOrTablet: false,
      isLoading: false,
      isFullscreenModalActive: false,
      isFilePreviewModalActive: false,
      isFullPage: true,
      isDataLoaded: false,
      searchTenant: null,
      backUrl: null,
      searchValue: "",
      post: null,
      showLogin: false,
      postCount: 0,
      view: {
        grid: false,
        list: false
      }
    };
  },
  mixins: [goTo, getScrollY],
  computed: {
    ...mapGetters(["searchPosts", "viewHeight", "darkMode"])
  },
  watch: {
    windowWidth: "changePostPosition",
    getScrollY: "handleScroll"
  },
  methods: {
    ...mapActions(["getSearchPosts"]),
    ...mapMutations(["setViewHeight", "setPlayMedia"]),
    showSearchInput(visible) {
      this.showSearch = visible;
    },
    setListView() {
      this.setPlayMedia(false);
      this.initialLoad = true;
      this.view.list = true;
      this.view.grid = false;
      this.setViewHeight(0);
      this.loadSearchPosts();
    },
    setGridView() {
      this.setPlayMedia(false);
      this.initialLoad = true;
      this.view.grid = true;
      this.view.list = false;
      this.setViewHeight(0);
      this.loadSearchPosts();
    },
    changePostPosition() {
      if (
        window.fullScreen ||
        (window.innerWidth == screen.width &&
          window.innerHeight == screen.height)
      ) {
        this.isFullScreen = true;
        return;
      } else if (this.isFullScreen) {
        this.isFullScreen = false;
      }

      const that = this;
      clearTimeout(this.doit);
      this.doit = setTimeout(function() {
        that.loadSearchPosts();
      }, 500);
    },
    sortPosts(value) {
      this.sort = value;
      this.initialLoad = true;
      this.loadSearchPosts();
    },
    search(value) {
      if (this.searchValue != value) {
        let searchUrl = "";
        if (this.backUrl) {
          searchUrl = `/search?searchValue=${value}&backUrl=${this.backUrl}`;
        } else {
          searchUrl = `/search?searchValue=${value}`;
        }
        this.goTo(searchUrl);
      }
    },
    loadSearchPosts() {
      this.isLoading = true;
      this.getSearchPosts({
        searchValue: this.searchValue,
        tenantId: this.tenantId,
        sort: this.sort || "new",
        view:
          this.view.list || this.windowWidth <= this.mobileWidth ? "list" : "",
        initialLoad: this.initialLoad
      }).then(data => {
        this.initialLoad = false;
        this.isLoading = false;
        this.postCount = data.postCount;
        this.isDataLoaded = true;
      });
    },
    fullscreen(post) {
      this.post = post;
      this.isFullscreenModalActive = true;
    },
    filePreview(post) {
      this.post = post;
      this.isFilePreviewModalActive = true;
    },
    handleScroll() {
      const scrollYPosition = window.scrollY + window.innerHeight;

      var additionalHeight = (this.viewHeight / 100) * 20;
      var wantedHeight =
        additionalHeight <= 540
          ? this.viewHeight + additionalHeight
          : this.viewHeight + 540;

      if (
        scrollYPosition >= wantedHeight &&
        this.searchPosts.length < this.postCount &&
        !this.isLoading
      ) {
        this.setViewHeight(scrollYPosition);
        this.loadSearchPosts();
      }
    }
  },
  created() {
    this.setViewHeight(0);
    window.scrollTo(0, 0);
    const params = this.$route.params;
    this.tenantId = params.tenant || "pinwall";
    this.isMobileOrTablet = checkIfMobileOrTablet(navigator.userAgent);
    this.view.list = this.windowWidth <= this.mobileWidth;
    this.view.grid = this.windowWidth > this.mobileWidth;

    if (this.isMobileOrTablet) {
      this.view.list = true;
      this.view.grid = false;
    }

    if (this.$route.query && this.$route.query.searchValue) {
      this.backUrl = this.$route.query.backUrl;
      if (this.windowWidth <= this.mobileWidth) {
        this.showSearch = true;
      }
      this.searchValue = this.$route.query.searchValue;
      this.loadSearchPosts();
    }
  }
};
</script>
